// src/components/UnsavedDialog.jsx
import React from "react";

export default function UnsavedDialog({
    open = false,
    onSaveAndExit,
    onExit,
    onCancel,
}) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[2100]">
            <div
                className="absolute inset-0 bg-slate-900/50 backdrop-blur-[1px]"
                onClick={onCancel}
            />
            <div className="absolute inset-0 flex items-center justify-center p-4">
                <div className="relative w-full max-w-xl rounded-2xl bg-white shadow-2xl border border-slate-100">
                    <button
                        onClick={onCancel}
                        className="absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50"
                        aria-label="Fermer"
                        title="Fermer"
                    >
                        ×
                    </button>

                    <div className="px-8 pt-8 pb-6 text-center">
                        <div className="mx-auto mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-sky-50">
                            <svg viewBox="0 0 24 24" width="30" height="30" className="text-sky-600">
                                <path
                                    fill="currentColor"
                                    d="M3 5h12a1 1 0 0 1 1 1v2H2V6a1 1 0 0 1 1-1zm-1 5h14v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10zm18 2h3v2h-3v-2zm0 4h3v2h-3v-2z"
                                />
                            </svg>
                        </div>
                        <h3 className="text-[18px] font-semibold text-slate-900">
                            Des modifications ne sont pas enregistrées
                        </h3>
                        <p className="mt-2 text-[13px] text-slate-600">
                            Si vous quittez maintenant, vos changements seront perdus.
                        </p>
                    </div>

                    <div className="px-6 pb-6 flex flex-col-reverse sm:flex-row sm:justify-center gap-2">
                        <button
                            onClick={onExit}
                            className="h-9 px-4 rounded-full border-gray-600 text-gray-600 hover:bg-rose-50 border bg-white"
                        >
                            Quitter sans enregistrer
                        </button>
                        <button
                            onClick={onSaveAndExit}
                            className="h-9 px-4 rounded-full bg-sky-700 text-white hover:bg-sky-600"
                        >
                            Enregistrer et quitter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
